import { useEffect } from 'react';
import { useCurrentInternalUser } from '../../lib/currentUser';
import { applyOttoMotionPreference } from '../../lib/motion';

// Carries internal_users.otto_motion_enabled from the user row onto the root
// element, where otto.css and the Otto schedulers can both see it.
//
// Renders nothing. It exists as a component rather than a call inside some
// existing one because the preference has to hold everywhere Otto can appear —
// including the loading curtain, which is on screen before the sidebar mounts —
// and App is the only place that is true of.
//
// It listens through useCurrentInternalUser, so the sp:current-user-refetch
// event that SidebarUserMenu already fires after saving the toggle brings this
// along with it. That is what makes the switch take effect immediately rather
// than on next reload.
//
// Mounted only for internal users, which is not a limitation: Otto is not
// reachable from any supplier-facing route. That was verified by walking the
// import graph from all twelve supplier entry points, not assumed — see
// ottoNotOnSupplierSide.test.js, which re-walks it so the claim cannot rot.
export default function OttoMotionPreference() {
  const { user } = useCurrentInternalUser();

  useEffect(() => {
    // Undefined while the row is loading. Treated as enabled, so Otto does not
    // freeze for a beat on every page load and then start moving.
    applyOttoMotionPreference(user?.otto_motion_enabled ?? true);
  }, [user?.otto_motion_enabled]);

  // Clear on unmount so signing out does not leave a stale "off" behind for
  // whoever signs in next on a shared machine.
  useEffect(() => () => applyOttoMotionPreference(true), []);

  return null;
}
